<!--
  ~ Copyright (c) 2026. Spin in het Web B.V. Apeldoorn.
  ~ Deze software mag alleen gebruikt / bekeken / gewijzigd worden volgens de voorwaarden die zijn vastgelegd in de overeenkomst tussen Ocaro B.V. en Spin in het Web B.V.
  -->

<button [class]="btnclass" title="Exporteer de zichtbare rijen naar Excel" (click)="export()"><span [class]="icon"></span></button>
